import { ClaveValor } from "../interfaces/claveValor";

export const MockParametros: ClaveValor[] = [
    {
      id: 1,
      clave: "LogoHeader",
      valor: "/static/media/Mateicos-48.b55486906fe20fa7bfe0.png"
    },
    {
      id: 2,
      clave: "Nombre",
      valor: "Drop"
    },
    {
      id: 3,
      clave: "Correo",
      valor: "ventas@dropmodular.com"
    },
    {
      id: 4,
      clave: "BackgroundColor",
      valor: "#FFFFFF"
    },
    {
      id: 5,
      clave: "FirstColor",
      valor: "#000000"
    },
    {
      id: 6,
      clave: "SecondColor",
      valor: "#bf345d"
    },
    {
      id: 7,
      clave: "ThirdColor",
      valor: "#d696a8"
    },
    {
      id: 8,
      clave: "FourthColor",
      valor: "#115778"
    },
    {
      id: 9,
      clave: "FifthColor",
      valor: "#7b7b84"
    },
    {
      id: 10,
      clave: "LogoFooter",
      valor: "/static/media/Mateicos-45.9feed3e0ab85f3d03583.png"
    },
    {
      id: 11,
      clave: "Instagram",
      valor: "https://www.instagram.com/drop.modular/"
    },
    {
      id: 12,
      clave: "Whatsapp",
      valor: "https://wa.me/1132357543"
    },
    {
      id: 13,
      clave: "Telefono",
      valor: "/static/media/Mateicos-45.9feed3e0ab85f3d03583.png"
    },
  ]